/** Default edge API roots when build env vars are not set (test). */
const DEFAULT_API_BASE_URL = 'https://test.api.sss.jsshuxintong.com';
const DEFAULT_OPEN_PLATFORM_URL = 'https://test.open.sss.jsshuxintong.com';

/** AI智慧监控 API 根地址（无尾部 /api） */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

/** 开放平台门户地址 */
export const OPEN_PLATFORM_URL =
  process.env.REACT_APP_OPEN_PLATFORM_URL || DEFAULT_OPEN_PLATFORM_URL;

/**
 * 移动端应用地址。
 * Android 门户展示与下载只认接口 `GET /app/version/latest` 的 downloadUrl
 *（管理端「安卓版版本更新」已发布包）；本项仅作构建期备用，登录页/下载中心不再用其覆盖接口空值。
 * iOS 仍使用 App Store / TestFlight 链接。
 */
export const ANDROID_APP_URL = (
  process.env.REACT_APP_ANDROID_APP_URL || ''
).trim();
export const IOS_APP_URL = (process.env.REACT_APP_IOS_APP_URL || '').trim();

export const APP_ENV = process.env.REACT_APP_ENV || 'test';
